import React, { useState, useEffect } from 'react';
import {
  FaCalendarAlt,
  FaUserMd,
  FaArrowRight,
  FaHeartbeat,
  FaStethoscope,
  FaBookMedical,
  FaShareAlt,
  FaClock,
  FaEye,
  FaComment,
  FaChevronLeft,
  FaChevronRight,
  FaStar,
  FaMedkit,
  FaFlask,
  FaProcedures,
  FaHandHoldingMedical
} from 'react-icons/fa';

const BlogsSection = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 6;

  // Categories with counts and icons
  const categories = [
    { name: 'All', count: 12, icon: <FaBookMedical /> },
    { name: 'Urology', count: 4, icon: <FaStethoscope /> },
    { name: 'Surgery', count: 3, icon: <FaProcedures /> },
    { name: 'Kidney', count: 2, icon: <FaFlask /> },
    { name: 'Cancer', count: 2, icon: <FaMedkit /> },
    { name: 'Wellness', count: 1, icon: <FaHeartbeat /> }
  ];

  // 12 Blog Posts – Each with unique, relevant Unsplash image
  const blogs = [
    {
      id: 1,
      image: "https://images.onlymyhealth.com/imported/images/2023/April/04_Apr_2023/2-Prostate.jpg",
      category: "Urology",
      title: "Prostate Health: Early Signs & Modern Treatments",
      date: "15 July 2025",
      excerpt: "Prostate issues affect 1 in 8 men. Learn about early detection, lifestyle changes, and advanced treatment options.",
      readTime: "6 min",
      views: "1.8k",
      comments: 42,
      tags: ["Prostate", "Men's Health"],
      featured: true,
      doctor: "Dr. Shailendra Shukla"
    },
    {
      id: 2,
      image: "https://tse1.mm.bing.net/th/id/OIP.GH7V2uk6flsI-Iqj2faE_AHaC9?rs=1&pid=ImgDetMain&o=7&rm=3",
      category: "Kidney",
      title: "Painless Kidney Stone Treatment & Recovery",
      date: "14 July 2025",
      excerpt: "Laser lithotripsy breaks kidney stones without surgery. Complete recovery guide with diet tips.",
      readTime: "5 min",
      views: "2.1k",
      comments: 56,
      tags: ["Kidney Stones", "Laser"],
      featured: true,
      doctor: "Dr. Rajesh Kumar"
    },
    {
      id: 3,
      image: "https://advancedsurg.net/wp-content/uploads/2018/07/Minimally-Invasive-Surgery.jpg",
      category: "Surgery",
      title: "Minimally Invasive Surgery: Benefits & Recovery",
      date: "13 July 2025",
      excerpt: "Laparoscopic procedures offer faster recovery, less pain, and minimal scarring.",
      readTime: "7 min",
      views: "2.5k",
      comments: 68,
      tags: ["Laparoscopy", "Surgery"],
      featured: false,
      doctor: "Dr. Priya Sharma"
    },
    {
      id: 4,
      image: "https://a57.foxnews.com/static.foxnews.com/foxnews.com/content/uploads/2025/07/1200/675/bladder-cancer-concept-scaled.jpg?ve=1&tl=1",
      category: "Cancer",
      title: "Bladder Cancer: Early Detection Saves Lives",
      date: "12 July 2025",
      excerpt: "Symptoms, risk factors, and advanced treatments. Early diagnosis increases survival to 95%.",
      readTime: "8 min",
      views: "1.9k",
      comments: 45,
      tags: ["Cancer", "Oncology"],
      featured: false,
      doctor: "Dr. Amit Patel"
    },
    {
      id: 5,
      image: "https://t4.ftcdn.net/jpg/04/58/19/91/360_F_458199170_BgV7UXpPgSA506VfjsOV3iQNUw8kVSRM.jpg",
      category: "Urology",
      title: "ED Treatment: Modern Solutions & Success Rates",
      date: "11 July 2025",
      excerpt: "Erectile dysfunction affects 30% men. 95% success with modern treatments. Medications, therapy, lifestyle.",
      readTime: "6 min",
      views: "2.3k",
      comments: 78,
      tags: ["ED", "Men's Health"],
      featured: true,
      doctor: "Dr. Shailendra Shukla"
    },
    {
      id: 6,
      image: "https://medicaldialogues.in/h-upload/2025/01/11/268619-chronic-kidney-disease.jpg",
      category: "Kidney",
      title: "Chronic Kidney Disease: Management Tips",
      date: "10 July 2025",
      excerpt: "Diet, medication, and monitoring to slow progression and maintain kidney function.",
      readTime: "7 min",
      views: "1.6k",
      comments: 34,
      tags: ["CKD", "Kidney Health"],
      featured: false,
      doctor: "Dr. Rajesh Kumar"
    },
    {
      id: 7,
      image: "https://tse1.mm.bing.net/th/id/OIP.4INXmybvyZefvG2xo0tN9wHaEK?rs=1&pid=ImgDetMain&o=7&rm=3",
      category: "Surgery",
      title: "Robotic Surgery: Precision in Urology",
      date: "09 July 2025",
      excerpt: "Da Vinci robotic surgery for prostate and kidney – unmatched precision, faster recovery.",
      readTime: "8 min",
      views: "2.8k",
      comments: 89,
      tags: ["Robotic", "Surgery"],
      featured: true,
      doctor: "Dr. Priya Sharma"
    },
    {
      id: 8,
      image: "https://tse1.mm.bing.net/th/id/OIP.-Esd7YWrTIRuZwPqzclFIgHaD4?rs=1&pid=ImgDetMain&o=7&rm=3",
      category: "Cancer",
      title: "Prostate Cancer Screening: Who & When?",
      date: "08 July 2025",
      excerpt: "PSA testing guidelines and modern screening methods. Early detection is key.",
      readTime: "5 min",
      views: "1.7k",
      comments: 41,
      tags: ["Prostate Cancer", "Screening"],
      featured: false,
      doctor: "Dr. Amit Patel"
    },
    {
      id: 9,
      image: "https://lirp.cdn-website.com/69c0b277/dms3rep/multi/opt/Urinary+tract+infection+-+Symptoms-+Causes-+Complications-+Prevention+and+Treatment-1920w.jpg",
      category: "Urology",
      title: "UTI in Women: Prevention & Treatment",
      date: "07 July 2025",
      excerpt: "50% women get UTI. Learn prevention, treatment, and when to see a specialist.",
      readTime: "4 min",
      views: "2.2k",
      comments: 62,
      tags: ["UTI", "Women's Health"],
      featured: false,
      doctor: "Dr. Shailendra Shukla"
    },
    {
      id: 10,
      image: "https://thereadystate.com/wp-content/uploads/2022/03/Surgery-Recovery-Protocol-1-300x300.jpg",
      category: "Surgery",
      title: "Post‑Op Recovery: Complete Guide",
      date: "06 July 2025",
      excerpt: "What to expect after urological surgery – timeline, restrictions, and healing tips.",
      readTime: "6 min",
      views: "1.5k",
      comments: 37,
      tags: ["Post-Op", "Recovery"],
      featured: false,
      doctor: "Dr. Priya Sharma"
    },
    {
      id: 11,
      image: "https://www.biologyonline.com/wp-content/uploads/2020/02/Kidneys-and-regulation-of-water-and-inorganic-ions-768x532.jpg",
      category: "Wellness",
      title: "Hydration & Kidney Health",
      date: "05 July 2025",
      excerpt: "Proper hydration prevents kidney stones. Daily water intake by age.",
      readTime: "3 min",
      views: "3.1k",
      comments: 92,
      tags: ["Hydration", "Wellness"],
      featured: true,
      doctor: "Dr. Rajesh Kumar"
    },
    {
      id: 12,
      image: "https://tse2.mm.bing.net/th/id/OIP.fI9xpmHKSMvwizlDiwmdsgHaE8?rs=1&pid=ImgDetMain&o=7&rm=3",
      category: "Urology",
      title: "Pediatric Urology: When to Consult",
      date: "04 July 2025",
      excerpt: "Common conditions in children and when to seek specialist care – early intervention matters.",
      readTime: "5 min",
      views: "1.4k",
      comments: 29,
      tags: ["Pediatric", "Children"],
      featured: false,
      doctor: "Dr. Shailendra Shukla"
    }
  ];

  // Helper for category gradient colors
  const getCategoryColor = (category) => {
    const colors = {
      'Urology': 'from-blue-500 to-blue-700',
      'Surgery': 'from-green-500 to-green-700',
      'Kidney': 'from-purple-500 to-purple-700',
      'Cancer': 'from-red-500 to-red-700',
      'Wellness': 'from-amber-500 to-amber-700'
    };
    return colors[category] || 'from-blue-500 to-green-500';
  };

  // Helper for category icon
  const getCategoryIcon = (category) => {
    const icons = {
      'Urology': <FaStethoscope />,
      'Surgery': <FaProcedures />,
      'Kidney': <FaFlask />,
      'Cancer': <FaMedkit />,
      'Wellness': <FaHeartbeat />
    };
    return icons[category] || <FaBookMedical />;
  };

  // Filter blogs by selected category
  const filteredBlogs = activeCategory === 'All'
    ? blogs
    : blogs.filter(blog => blog.category === activeCategory);

  // Pagination logic
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 600, behavior: 'smooth' });
  };

  const handleShare = (blog) => {
    if (navigator.share) {
      navigator.share({
        title: blog.title,
        text: blog.excerpt,
        url: window.location.href,
      });
    } else {
      navigator.clipboard.writeText(window.location.href);
      alert('Link copied!');
    }
  };

  return (
    <section className="py-12 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Header – Compact */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center mb-2">
            <div className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-500 to-blue-700 flex items-center justify-center mr-3 shadow-md">
              <FaBookMedical className="text-white text-xl" />
            </div>
            <div className="text-left">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
                Medical <span className="bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">Insights</span>
              </h2>
              <p className="text-gray-600 text-sm">Expert knowledge from our specialists</p>
            </div>
          </div>
        </div>

        {/* Categories – Smaller pills */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2 justify-center">
            {categories.map((cat) => (
              <button
                key={cat.name}
                onClick={() => {
                  setActiveCategory(cat.name);
                  setCurrentPage(1);
                }}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 flex items-center ${
                  activeCategory === cat.name
                    ? `bg-gradient-to-r ${getCategoryColor(cat.name)} text-white shadow`
                    : 'bg-white text-gray-700 border border-gray-200 hover:border-blue-300 hover:bg-blue-50'
                }`}
              >
                <span className="mr-1.5">{cat.icon}</span>
                {cat.name}
                <span className="ml-1.5 bg-white/20 px-1.5 py-0.5 rounded-full text-xs">
                  {cat.count}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Blogs Grid – Compact Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-10">
          {currentBlogs.map((blog) => (
            <div
              key={blog.id}
              className="group bg-white rounded-xl shadow hover:shadow-lg overflow-hidden transition-all duration-300 border border-gray-100 flex flex-col h-full"
            >
              {/* Image – Smaller */}
              <div className="relative h-40 overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                {/* Category Badge – Smaller */}
                <div className="absolute top-2 left-2">
                  <div className={`bg-gradient-to-r ${getCategoryColor(blog.category)} text-white px-2.5 py-1 rounded-full text-xs font-medium shadow flex items-center`}>
                    {getCategoryIcon(blog.category)}
                    <span className="ml-1">{blog.category}</span>
                  </div>
                </div>
                {/* Featured Badge – Smaller */}
                {blog.featured && (
                  <div className="absolute top-2 right-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white px-2 py-0.5 rounded-full text-[10px] font-bold shadow flex items-center">
                    <FaStar className="mr-0.5 text-[10px]" />
                    Featured
                  </div>
                )}
              </div>

              {/* Content – Compact padding */}
              <div className="p-4 flex-grow flex flex-col">
                {/* Date & Read Time – Small */}
                <div className="flex items-center justify-between mb-2 text-gray-500 text-xs">
                  <div className="flex items-center">
                    <FaCalendarAlt className="mr-1 text-blue-500 text-[10px]" />
                    {blog.date}
                  </div>
                  <div className="flex items-center">
                    <FaClock className="mr-1 text-green-500 text-[10px]" />
                    {blog.readTime}
                  </div>
                </div>

                {/* Title – Smaller */}
                <h3 className="text-base font-bold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors line-clamp-2">
                  {blog.title}
                </h3>

                {/* Excerpt – 2 lines only */}
                <p className="text-gray-600 text-xs mb-3 line-clamp-2">
                  {blog.excerpt}
                </p>

                {/* Doctor – Compact chip */}
                <div className="flex items-center mb-3 p-2 bg-gray-50 rounded-lg">
                  <div className="w-7 h-7 rounded-full bg-gradient-to-r from-blue-100 to-blue-200 flex items-center justify-center mr-2">
                    <FaUserMd className="text-blue-600 text-xs" />
                  </div>
                  <div>
                    <div className="font-medium text-gray-900 text-xs">{blog.doctor}</div>
                  </div>
                </div>

                {/* Tags – Small */}
                <div className="flex flex-wrap gap-1 mb-3">
                  {blog.tags.map((tag, idx) => (
                    <span
                      key={idx}
                      className="inline-block bg-blue-50 text-blue-700 px-2 py-0.5 rounded-full text-[10px] font-medium border border-blue-100"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>

                {/* Stats & Actions – Compact */}
                <div className="flex items-center justify-between mt-2 pt-2 border-t border-gray-100">
                  <div className="flex items-center space-x-3 text-gray-500">
                    <div className="flex items-center text-xs">
                      <FaEye className="mr-1 text-blue-500 text-[10px]" />
                      <span>{blog.views}</span>
                    </div>
                    <div className="flex items-center text-xs">
                      <FaComment className="mr-1 text-green-500 text-[10px]" />
                      <span>{blog.comments}</span>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2">
                    <button
                      onClick={() => handleShare(blog)}
                      className="w-7 h-7 rounded-full bg-gray-100 hover:bg-blue-50 text-gray-600 hover:text-blue-600 flex items-center justify-center transition-colors"
                      title="Share"
                    >
                      <FaShareAlt className="text-xs" />
                    </button>
                    <button className="group/btn bg-gradient-to-r from-blue-500 to-blue-700 text-white px-3 py-1.5 rounded-lg text-xs font-medium hover:from-blue-600 hover:to-blue-800 transition-all flex items-center">
                      Read
                      <FaArrowRight className="ml-1.5 text-[10px] transform group-hover/btn:translate-x-0.5 transition-transform" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination – Compact */}
        {totalPages > 1 && (
          <div className="flex flex-wrap items-center justify-center gap-2 mb-10">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition flex items-center ${
                currentPage === 1
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
              }`}
            >
              <FaChevronLeft className="mr-1 text-xs" />
              Prev
            </button>
            {[...Array(totalPages)].map((_, idx) => (
              <button
                key={idx + 1}
                onClick={() => handlePageChange(idx + 1)}
                className={`w-8 h-8 rounded-lg text-xs font-medium transition ${
                  currentPage === idx + 1
                    ? `bg-gradient-to-r ${getCategoryColor(activeCategory)} text-white shadow`
                    : 'bg-white text-gray-700 border border-gray-200 hover:border-blue-300'
                }`}
              >
                {idx + 1}
              </button>
            ))}
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition flex items-center ${
                currentPage === totalPages
                  ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                  : 'bg-blue-50 text-blue-700 hover:bg-blue-100'
              }`}
            >
              Next
              <FaChevronRight className="ml-1 text-xs" />
            </button>
          </div>
        )}

        {/* Newsletter – Compact */}
        <div className="bg-gradient-to-r from-blue-600 to-green-600 rounded-xl p-5 text-white shadow-md">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="md:w-2/3 mb-4 md:mb-0">
              <div className="flex items-center mb-2">
                <div className="w-8 h-8 rounded-full bg-white/20 flex items-center justify-center mr-2">
                  <FaBookMedical className="text-white text-sm" />
                </div>
                <h3 className="text-lg font-bold">Weekly Health Updates</h3>
              </div>
              <p className="text-blue-100 text-xs mb-2">
                Subscribe for expert insights and latest treatments.
              </p>
              <div className="flex items-center text-[10px]">
                <span className="flex items-center mr-4">
                  <FaStar className="text-amber-300 mr-1 text-[10px]" />
                  No spam
                </span>
                <span className="flex items-center">
                  <FaUserMd className="text-green-300 mr-1 text-[10px]" />
                  From specialists
                </span>
              </div>
            </div>
            <div className="md:w-1/3 w-full">
              <div className="flex flex-col sm:flex-row gap-2">
                <input
                  type="email"
                  placeholder="Your email"
                  className="flex-1 px-3 py-2 rounded-lg text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white"
                />
                <button className="bg-white text-blue-600 px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-50 transition">
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* CTA – Compact */}
        <div className="mt-8 text-center">
          <div className="inline-flex items-center bg-gradient-to-r from-blue-50 to-green-50 px-5 py-3 rounded-xl border border-blue-100">
            <div className="text-left mr-4">
              <h4 className="font-semibold text-gray-900 text-sm">Need Consultation?</h4>
              <p className="text-gray-600 text-xs">Book with our specialists</p>
            </div>
            <button className="bg-gradient-to-r from-blue-600 to-green-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:from-blue-700 hover:to-green-700 transition shadow">
              Book Appointment
            </button>
          </div>
        </div>
      </div>

      <style jsx>{`
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </section>
  );
};

export default BlogsSection;